import { DayOfWeek, SchedulingType } from '../../common/constants';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

export class ProfileSubscriptionBase {
  id: number | null = null;
  hours: number[] | null = null;
  day: DayOfWeek | null = null;
  schedulingType: SchedulingType = SchedulingType.Weekly;

  constructor(params?: ProfileSubscriptionBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ProfileSubscription extends ProfileSubscriptionBase {
  receiveEmptyEmails = true;

  constructor(params?: ProfileSubscription) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ProfileSubscriptionForm {
  constructor(
    model: Partial<ProfileSubscription>,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number | null> = fb.control<number>(model.id, []),
    public hours: FormControl<number[] | null> = fb.control<number[]>(model.hours, [Validators.required]),
    public schedulingType: FormControl<SchedulingType> = fb.control<SchedulingType>(model.schedulingType, [
      Validators.required,
    ]),
    public day: FormControl<DayOfWeek> = fb.control<DayOfWeek>(model.day, []),
    public receiveEmptyEmails: FormControl<boolean> = fb.control<boolean>(model.receiveEmptyEmails, []),
  ) {}
}
